<template>
  <div id="iute-branches" class="list-group list-group-escape-container">
    <router-link
        v-for="branch of getBranches()" v-bind:key="branch.id"
        :to="{ name: detailsRoute, params: { id: branch.id }}"
        class="branch list-group-item list-group-item-action list-group-item-with-icon">
      <div>
        <strong class="branch-name">{{ branch.title }}</strong>
        <div class="small text-muted branch-address">{{ branch.streetAddress }}</div>
      </div>
      <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"></Icon>
    </router-link>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
import BranchesMixin from '@shared/mixins/BranchesMixin'

export default {
  name: 'BranchesList',
  components: { Icon },
  mixins: [BranchesMixin],
  props: {
    detailsRoute: { type: String, default: 'branch' }
  }
}
</script>
